// Define steps configuration in a central location
export const STEPS = [
  { id: 'contact', title: 'Contact Info' },
  { id: 'experience', title: 'Experience' },
  { id: 'education', title: 'Education' },
  { id: 'certifications', title: 'Certifications' },
  { id: 'skills', title: 'Skills' },
  { id: 'summary', title: 'Summary' },
  { id: 'template', title: 'Template' },
  { id: 'finalize', title: 'Finalize' }
] as const;

export const STEP_IDS = STEPS.map(step => step.id);

export type StepId = typeof STEP_IDS[number];

export function getStepTitle(stepId: StepId): string {
  return STEPS.find(step => step.id === stepId)?.title || stepId;
}

export function getStepIndex(stepId: StepId): number {
  return STEP_IDS.indexOf(stepId);
}

export function isFirstStep(stepId: StepId): boolean {
  return getStepIndex(stepId) === 0;
}

export function isLastStep(stepId: StepId): boolean {
  return getStepIndex(stepId) === STEP_IDS.length - 1;
}

export function getNextStep(stepId: StepId): StepId | null {
  const nextIndex = getStepIndex(stepId) + 1;
  return nextIndex < STEP_IDS.length ? STEP_IDS[nextIndex] : null;
}

export function getPreviousStep(stepId: StepId): StepId | null {
  const prevIndex = getStepIndex(stepId) - 1;
  return prevIndex >= 0 ? STEP_IDS[prevIndex] : null;
}